import classNames from 'classnames';

import { MAX_DISPLAYED_PAGES, MAX_DISPLAYED_SIDES, TPaginationProps } from './Pagination';
import Icon from '@/components/Icon/Icon';

const PaginationEnd = ({ handlePageOpen, currentPageIdx, totalPages }: TPaginationProps) => {
    const items = [];

    const endItemsAmount =
        currentPageIdx > totalPages - MAX_DISPLAYED_SIDES
            ? MAX_DISPLAYED_SIDES
            : totalPages - currentPageIdx + 1;

    for (let i = totalPages - endItemsAmount; i < totalPages; i++) {
        items.push(
            <button
                key={i}
                className={classNames('tw-px-[10px] focus:tw-outline-none', {
                    'tw-text-paginationActive': currentPageIdx === i,
                    'tw-text-paginationInactive': currentPageIdx !== i,
                    'hover:tw-bg-[#eee]': currentPageIdx !== i,
                })}
                onClick={() => handlePageOpen(i)}
            >
                {i + 1}
            </button>,
        );
    }
    return (
        <>
            <button
                key={0}
                className={classNames('tw-px-[10px] focus:tw-outline-none', {
                    'tw-text-paginationActive': currentPageIdx === 0,
                    'tw-text-paginationInactive': currentPageIdx !== 0,
                    'hover:tw-bg-[#eee]': currentPageIdx !== 0,
                })}
                onClick={() => handlePageOpen(0)}
            >
                1
            </button>
            <Icon type="ellipsis" width={16} key={1} className="tw-self-end tw-fill-menuText" />
            {items}
        </>
    );
};

export default PaginationEnd;
